import React from 'react';
import LegalPage from './LegalPage';
import { PRIVACY } from './legalContent';

const Privacy: React.FC = () => <LegalPage doc={PRIVACY} />;

export default Privacy;
